import React from 'react'

export const Breadcrumb = () => {
    return (
        <div className="breadcrumb bg-gray-50 p-2 lg:px-16">
         <ul className="flex text-xs font-light text-gray-500">
             <li><a href="/">Home</a></li>
             <li>Shop</li>
         </ul>   
        </div>
    )
}
